export const navLinks = [
  { id: "replay", label: "直播回放" },
  { id: "welfare", label: "福利视频" },
  { id: "ranking", label: "热门主播" },
  { id: "category", label: "分类专区" },
  { id: "dynamics", label: "主播动态" },
  { id: "guide", label: "观看指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStreamers = [
  {
    id: "h1",
    name: "星野小鹿",
    tag: "钢琴 · 音乐",
    image:
      "https://readdy.ai/api/search-image?query=smiling%20young%20female%20live%20streamer%20in%20a%20cozy%20studio%20with%20warm%20neon%20accent%20lighting%20soft%20neutral%20background%20modern%20creator%20aesthetic%20high%20detail%20editorial%20portrait%20photography&width=600&height=800&seq=51v-hero-01&orientation=portrait",
    live: true,
    viewers: "1.8万",
    note: "今晚 20:00 钢琴串烧专场",
  },
  {
    id: "h2",
    name: "阿KEN",
    tag: "电竞 · 游戏",
    image:
      "https://readdy.ai/api/search-image?query=gaming%20streamer%20desk%20with%20dual%20monitors%20rgb%20glow%20and%20headset%20warm%20dim%20room%20background%20modern%20creator%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=800&seq=51v-hero-02&orientation=portrait",
    live: false,
    viewers: "9,640",
    note: "钻石冲分局回放已上线",
  },
  {
    id: "h3",
    name: "夏之和弦",
    tag: "民谣 · 现场",
    image:
      "https://readdy.ai/api/search-image?query=acoustic%20singer%20with%20guitar%20under%20a%20warm%20spotlight%20on%20a%20small%20stage%20soft%20dark%20background%20modern%20creator%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=800&seq=51v-hero-03&orientation=portrait",
    live: true,
    viewers: "6,210",
    note: "凌晨民谣连麦进行中",
  },
  {
    id: "h4",
    name: "江边的风",
    tag: "户外 · 旅行",
    image:
      "https://readdy.ai/api/search-image?query=travel%20vlogger%20walking%20a%20city%20street%20at%20golden%20hour%20holding%20a%20camera%20warm%20soft%20background%20modern%20creator%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=800&seq=51v-hero-04&orientation=portrait",
    live: false,
    viewers: "4,380",
    note: "山野露营记第四期更新",
  },
];

export const heroStats = [
  { value: "12.6万", label: "收录主播" },
  { value: "38万+", label: "直播回放" },
  { value: "1,240", label: "福利合辑" },
  { value: "每日 06:00", label: "榜单更新" },
];

export const replayCategories = [
  "全部",
  "才艺",
  "游戏",
  "音乐",
  "舞蹈",
  "生活",
  "户外",
  "知识",
];

export const replayVideos = [
  {
    id: "r1",
    title: "深夜厨房｜一锅暖冬菌汤面，从备菜到出锅全记录",
    streamer: "茶茶酱",
    category: "生活",
    duration: "2:04:18",
    views: "38.2万",
    date: "10-09",
    hot: true,
    summary: "完整展示汤底熬制、配菜处理和出锅摆盘，适合照着做的一期慢节奏回放。",
    tags: ["美食", "治愈"],
    image:
      "https://readdy.ai/api/search-image?query=home%20kitchen%20cooking%20livestream%20with%20steaming%20noodles%20warm%20tungsten%20light%20soft%20neutral%20background%20cozy%20aesthetic%20high%20detail%20editorial%20food%20photography&width=800&height=450&seq=51v-rp-01&orientation=landscape",
  },
  {
    id: "r2",
    title: "峡谷冲分局｜钻石段位极限翻盘五连胜实况",
    streamer: "阿KEN",
    category: "游戏",
    duration: "3:12:45",
    views: "76.4万",
    date: "10-09",
    hot: true,
    summary: "从逆风开局到连胜收场，逐局复盘关键团战决策与出装思路。",
    tags: ["电竞", "上分"],
    image:
      "https://readdy.ai/api/search-image?query=esports%20arena%20with%20blue%20and%20orange%20stage%20lights%20large%20screens%20and%20crowd%20soft%20dark%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-rp-02&orientation=landscape",
  },
  {
    id: "r3",
    title: "镜前随机舞蹈｜新学的编舞一次过一遍到底",
    streamer: "甜心柚柚",
    category: "舞蹈",
    duration: "1:26:30",
    views: "52.1万",
    date: "10-08",
    hot: false,
    summary: "随机点歌随机编舞，中途仅保留两次重来，完整呈现练习过程。",
    tags: ["编舞", "随机"],
    image:
      "https://readdy.ai/api/search-image?query=dance%20practice%20studio%20with%20large%20mirrors%20and%20warm%20light%20soft%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-rp-03&orientation=landscape",
  },
  {
    id: "r4",
    title: "凌晨民谣｜木吉他翻唱十首老歌，陪你加班到天亮",
    streamer: "夏之和弦",
    category: "音乐",
    duration: "2:48:12",
    views: "44.7万",
    date: "10-08",
    hot: false,
    summary: "十首经典民谣的指弹改编，含每首歌的和弦走向讲解与弹唱示范。",
    tags: ["民谣", "弹唱"],
    image:
      "https://readdy.ai/api/search-image?query=cozy%20room%20acoustic%20guitar%20session%20with%20warm%20lamp%20light%20soft%20neutral%20background%20intimate%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-rp-04&orientation=landscape",
  },
  {
    id: "r5",
    title: "山野露营记｜篝火煮茶看银河，全程无剪辑",
    streamer: "江边的风",
    category: "户外",
    duration: "4:05:37",
    views: "91.3万",
    date: "10-07",
    hot: true,
    summary: "海拔 1800 米营地整晚实录，包含搭帐篷、生火、煮茶与星空延时片段。",
    tags: ["露营", "星空"],
    image:
      "https://readdy.ai/api/search-image?query=night%20camping%20bonfire%20scene%20under%20a%20starry%20sky%20warm%20glow%20soft%20dark%20background%20adventure%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-rp-05&orientation=landscape",
  },
  {
    id: "r6",
    title: "数码开箱｜三款当家旗舰横评，续航实测拉满",
    streamer: "老周聊数码",
    category: "知识",
    duration: "1:52:20",
    views: "33.9万",
    date: "10-07",
    hot: false,
    summary: "统一环境下的续航、影像与散热对比，附完整测试数据表格。",
    tags: ["数码", "横评"],
    image:
      "https://readdy.ai/api/search-image?query=tech%20review%20desk%20with%20smartphones%20and%20gadgets%20under%20clean%20bright%20light%20soft%20neutral%20background%20minimal%20aesthetic%20high%20detail%20editorial%20product%20photography&width=800&height=450&seq=51v-rp-06&orientation=landscape",
  },
  {
    id: "r7",
    title: "情绪树洞｜陪你聊到深夜的电台式连麦现场",
    streamer: "苏晴Suki",
    category: "才艺",
    duration: "2:33:09",
    views: "67.8万",
    date: "10-06",
    hot: false,
    summary: "开放连麦的深夜电台，围绕工作、成长与关系三个话题展开对谈。",
    tags: ["电台", "谈心"],
    image:
      "https://readdy.ai/api/search-image?query=warm%20radio%20studio%20microphone%20and%20headphones%20with%20soft%20amber%20light%20soft%20neutral%20background%20intimate%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-rp-07&orientation=landscape",
  },
  {
    id: "r8",
    title: "钢琴串烧｜把三十首流行金曲接成一首曲子",
    streamer: "星野小鹿",
    category: "音乐",
    duration: "58:44",
    views: "112.6万",
    date: "10-05",
    hot: true,
    summary: "从选曲到转调设计的完整说明，附段落时间轴方便跳转视听。",
    tags: ["钢琴", "串烧"],
    image:
      "https://readdy.ai/api/search-image?query=grand%20piano%20on%20an%20empty%20stage%20with%20warm%20spotlight%20soft%20dark%20background%20elegant%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-rp-08&orientation=landscape",
  },
];

export const welfareTabs = ["全部合辑", "高能名场面", "治愈陪伴", "才艺精选", "旅途现场", "轻松解压"];

export const welfareCollections = [
  {
    id: "c1",
    title: "年度高能名场面合辑",
    category: "高能名场面",
    count: 86,
    duration: "合计 12.5 小时",
    desc: "把全年直播间里最出圈的临场反应与意外瞬间剪成一条合集，每个片段都标注了原直播日期，方便回看完整场次。",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20abstract%20neon%20light%20streaks%20on%20a%20dark%20warm%20background%20highlight%20reel%20aesthetic%20high%20detail%20graphic%20design&width=800&height=450&seq=51v-cl-01&orientation=landscape",
  },
  {
    id: "c2",
    title: "治愈陪伴夜场精选",
    category: "治愈陪伴",
    count: 42,
    duration: "合计 9.2 小时",
    desc: "来自深夜电台与轻声聊天场的片段，语速偏慢、背景音干净，适合睡前或通勤时当作背景音陪伴。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20comedy%20stage%20with%20microphone%20and%20soft%20spotlight%20soft%20neutral%20background%20joyful%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-cl-02&orientation=landscape",
  },
  {
    id: "c3",
    title: "才艺舞台高光合集",
    category: "才艺精选",
    count: 58,
    duration: "合计 7.6 小时",
    desc: "收录声乐、器乐、舞蹈类主播的舞台时刻，按曲风分组并附表演者与曲目信息，适合按兴趣挑着看。",
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20orange%20spotlights%20and%20silhouette%20crowd%20soft%20dark%20background%20energetic%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-cl-03&orientation=landscape",
  },
  {
    id: "c4",
    title: "旅途与户外名景",
    category: "旅途现场",
    count: 37,
    duration: "合计 10.4 小时",
    desc: "把户外直播中的日出、云海、海岸线等长镜头单独整理出来，画质按 1080P 保留，无跳剪与配乐叠加。",
    cover:
      "https://readdy.ai/api/search-image?query=travel%20vlog%20montage%20of%20coastal%20sunset%20and%20city%20lights%20warm%20tones%20soft%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=800&height=450&seq=51v-cl-04&orientation=landscape",
  },
];

export const rankingPeriods = ["今日榜", "本周榜", "本月榜"];

export const hotStreamers = [
  { id: "s1", rank: 1, name: "星野小鹿", category: "音乐", score: "98.6", fans: "412.8万", growth: "+3.2万", tag: "钢琴专场" },
  { id: "s2", rank: 2, name: "阿KEN", category: "游戏", score: "96.1", fans: "386.5万", growth: "+2.7万", tag: "峡谷冲分" },
  { id: "s3", rank: 3, name: "甜心柚柚", category: "舞蹈", score: "94.8", fans: "352.1万", growth: "+2.1万", tag: "随机编舞" },
  { id: "s4", rank: 4, name: "江边的风", category: "户外", score: "92.4", fans: "298.7万", growth: "+1.9万", tag: "山野露营" },
  { id: "s5", rank: 5, name: "夏之和弦", category: "音乐", score: "90.9", fans: "271.3万", growth: "+1.5万", tag: "凌晨民谣" },
  { id: "s6", rank: 6, name: "苏晴Suki", category: "才艺", score: "89.2", fans: "256.9万", growth: "+1.2万", tag: "深夜电台" },
  { id: "s7", rank: 7, name: "茶茶酱", category: "生活", score: "87.6", fans: "231.4万", growth: "+0.9万", tag: "深夜厨房" },
  { id: "s8", rank: 8, name: "老周聊数码", category: "知识", score: "85.3", fans: "204.6万", growth: "+0.7万", tag: "数码横评" },
];

export const categoryZones = [
  {
    id: "z1",
    name: "才艺",
    icon: "ri-mic-line",
    count: 268,
    desc: "电台连麦、脱口秀、配音与临场互动",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20stage%20microphone%20with%20soft%20amber%20light%20simple%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=600&seq=51v-cat-01&orientation=squarish",
  },
  {
    id: "z2",
    name: "游戏",
    icon: "ri-gamepad-line",
    count: 412,
    desc: "上分实况、赛事解说与新游试玩",
    cover:
      "https://readdy.ai/api/search-image?query=game%20controller%20with%20warm%20rgb%20glow%20simple%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20product%20photography&width=600&height=600&seq=51v-cat-02&orientation=squarish",
  },
  {
    id: "z3",
    name: "音乐",
    icon: "ri-music-2-line",
    count: 356,
    desc: "弹唱、翻唱、器乐演奏与点歌现场",
    cover:
      "https://readdy.ai/api/search-image?query=acoustic%20guitar%20and%20headphones%20with%20warm%20light%20simple%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20product%20photography&width=600&height=600&seq=51v-cat-03&orientation=squarish",
  },
  {
    id: "z4",
    name: "舞蹈",
    icon: "ri-body-scan-line",
    count: 224,
    desc: "编舞教学、随机舞蹈与舞台合集",
    cover:
      "https://readdy.ai/api/search-image?query=ballet%20shoes%20on%20a%20wooden%20floor%20with%20warm%20light%20simple%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=600&seq=51v-cat-04&orientation=squarish",
  },
  {
    id: "z5",
    name: "生活",
    icon: "ri-home-smile-line",
    count: 301,
    desc: "做饭、手作、整理与日常陪伴",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20home%20desk%20with%20plants%20and%20a%20cup%20of%20tea%20warm%20light%20simple%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=600&seq=51v-cat-05&orientation=squarish",
  },
  {
    id: "z6",
    name: "户外",
    icon: "ri-landscape-line",
    count: 187,
    desc: "露营、徒步、旅拍与夜景星空",
    cover:
      "https://readdy.ai/api/search-image?query=hiking%20backpack%20and%20boots%20near%20a%20mountain%20trail%20warm%20sunset%20light%20simple%20neutral%20background%20modern%20aesthetic%20high%20detail%20editorial%20photography&width=600&height=600&seq=51v-cat-06&orientation=squarish",
  },
];

export const dynamics = [
  {
    id: "d1",
    date: "10-09",
    time: "21:40",
    streamer: "星野小鹿",
    type: "开播预告",
    content: "周六 20:00 钢琴串烧专场，本期主题是「九十年代金曲重编」，已开放点歌收集。",
    tag: "预告",
  },
  {
    id: "d2",
    date: "10-09",
    time: "15:12",
    streamer: "阿KEN",
    type: "回放上线",
    content: "钻石段位冲分局完整回放已上线，新增逐局时间轴，方便直接跳到关键团战。",
    tag: "回放",
  },
  {
    id: "d3",
    date: "10-08",
    time: "23:05",
    streamer: "苏晴Suki",
    type: "栏目调整",
    content: "深夜电台改为每周三、周六两期，本期话题是「如何和压力相处」，欢迎连麦。",
    tag: "栏目",
  },
  {
    id: "d4",
    date: "10-08",
    time: "12:30",
    streamer: "江边的风",
    type: "拍摄记录",
    content: "山野露营记第四期完成拍摄，本次营地海拔 1800 米，正片预计下周一与大家见面。",
    tag: "记录",
  },
  {
    id: "d5",
    date: "10-07",
    time: "19:48",
    streamer: "甜心柚柚",
    type: "合集更新",
    content: "随机舞蹈合集更新至第 26 期，本期新增三支编舞的分段教学说明。",
    tag: "合集",
  },
  {
    id: "d6",
    date: "10-07",
    time: "10:20",
    streamer: "老周聊数码",
    type: "内容预告",
    content: "下期横评主题定为「中端机续航实测」，会在直播间同步展示测试原始数据。",
    tag: "预告",
  },
];

export const guides = [
  {
    step: "01",
    title: "先看榜单找方向",
    desc: "首页的热门主播榜按人气值排序，可以先从榜单里挑一个感兴趣的主播，再进入他的回放列表。",
    icon: "ri-trophy-line",
  },
  {
    step: "02",
    title: "用分类筛回放",
    desc: "直播回放区支持按才艺、游戏、音乐等分类筛选，也能直接搜索标题或主播名，几秒内定位到想看的一场。",
    icon: "ri-filter-3-line",
  },
  {
    step: "03",
    title: "按合辑看精华",
    desc: "不想看完整场次时，可以从福利合辑里挑主题，合辑已把高能片段按类型整理好，适合碎片时间浏览。",
    icon: "ri-play-list-2-line",
  },
  {
    step: "04",
    title: "跟动态不错过更新",
    desc: "主播动态按时间倒序排列，开播预告、回放上线与栏目调整都会同步，关注主线就不会漏掉新作品。",
    icon: "ri-notification-3-line",
  },
];

export const faqs = [
  {
    q: "这里的内容是怎么整理的？",
    a: "回放与合辑均按主播、分类与时间三个维度整理，每一条都标注了主播昵称、分类、时长与上线日期，合辑内还会保留原始场次日期，方便回溯完整内容。",
  },
  {
    q: "找不到想看的某一期怎么办？",
    a: "可以先用回放区的搜索框输入主播名或标题关键词，再用分类标签缩小范围。若仍没有结果，说明该场次暂未收录，可以查看该主播的动态页确认是否已上线。",
  },
  {
    q: "榜单是根据什么排序的？",
    a: "榜单综合了近期的观看量、互动量与更新频率，按今日、本周、本月三个周期分别计算，页面上的数值仅代表当前统计周期，会随数据更新而变动。",
  },
  {
    q: "合辑和完整回放有什么区别？",
    a: "合辑是从多场直播中裁剪出的主题片段集合，适合快速浏览；完整回放则保留整场直播的原始顺序与节奏，适合想要完整了解一场内容的浏览者。",
  },
  {
    q: "浏览需要注册账号吗？",
    a: "本页只是内容导览，筛选、搜索与展开操作全部在本地完成，浏览时不需要注册或登录，也不会上传任何个人信息。",
  },
  {
    q: "手机上可以正常浏览吗？",
    a: "可以。页面针对手机做了适配，卡片会自动变为单列或双列，筛选栏支持横向滑动，折叠类内容也能点击展开阅读。",
  },
];

export const marqueeItems = [
  "星野小鹿 · 钢琴串烧专场 周六 20:00 开播",
  "江边的风 · 山野露营记第四期正片预告",
  "甜心柚柚 · 随机舞蹈合集更新至第 26 期",
  "苏晴Suki · 深夜电台改为每周三、周六",
  "阿KEN · 钻石冲分局回放新增逐局时间轴",
  "老周聊数码 · 中端机续航实测直播预约中",
];